<template>
  <section id="osrHfTabSection" class="section pretty-top pretty-bottom">
    <h2 class="has-text-centered">
      {{ $t("profile.OSRBirdStatus.osrHfTabSection.sectionHeader", {sppName: state?.sppName}) }}
    </h2>
    <div class="profile richtext centered" v-html="sppContent.WebOSRChartDescription"></div>
    <div class="container">
      <osr-sector-effect-chart-layout :data="osrChartData" :currentHF="currentHF"/>
    </div>
  </section>
</template>
<script>
// import { reactive, ref, watch } from 'vue';
import { osrHFTabs as tabs } from '@/config/profile-config';
import { useApp } from '@/composables/state/profileState';
import OSRSectorEffectChartLayout from './sectorCharts/OSRSectorEffectChartLayout.vue';
export default {
  name: 'osr-sector-effect-sub-section',
  components: { 'osr-sector-effect-chart-layout': OSRSectorEffectChartLayout },
  setup (props) {
    const { state, osrChartData, sppContent } = useApp();
    return {
      osrChartData,
      sppContent,
      state,
      tabs,
    }
  },
}
</script>

<style scoped>
.search-bar-container {
    display: flex;
    position: relative;
    width: 100%;
    height: 36px;
    min-height: 36px;
}

p span {
  padding: 5px;
}

.button {
  margin-right: 10px;
}
.tabButton {
  margin-bottom: 20px;
}
</style>
